"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentHeader = void 0;
const common_1 = require("../../common");
const models_1 = require("../../partners/models");
const models_2 = require("../../setup/models");
const enums_1 = require("../enums");
const shipment_line_model_1 = require("./shipment-line.model");
const shipping_kit_model_1 = require("./shipping-kit.model");
class ShipmentHeader extends common_1.MongoDocument {
}
exports.ShipmentHeader = ShipmentHeader;
//# sourceMappingURL=shipment-header.model.js.map